import { ChipArrayField } from 'admin/fields/ChipArrayField';
import { SERVICE_AREA_TYPES } from 'admin/userRelations/userRelationUtils';
import { USER_ROLES } from 'admin/users/userUtils';
import { AuthContext } from 'common/providers/AuthContextProvider/AuthContextProvider';
import { Role, useCurrentUserQuery } from 'generated/graphql';
import { useContext } from 'react';
import {
  ArrayField,
  ChipField,
  DateField,
  EditButton,
  NumberField,
  Show,
  SimpleShowLayout,
  SingleFieldList,
  TextField,
  TopToolbar,
} from 'react-admin';

interface CustomActionsProps {
  showEdit?: boolean;
}
const CustomActions: React.FC<CustomActionsProps> = ({ showEdit = true }) => (
  <TopToolbar>{showEdit && <EditButton />}</TopToolbar>
);

export const StaffShow: React.FC = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const { data } = useCurrentUserQuery({ skip: !isAuthenticated });
  let showEdit = false;

  const hasAnyRole = (allowedRoles: Role[]) =>
    isAuthenticated && data?.user?.roles?.some((role: Role) => allowedRoles.includes(role));

  if (hasAnyRole([Role.RoleAdmin])) {
    showEdit = true;
  }

  return (
    <Show actions={<CustomActions showEdit={showEdit} />}>
      <SimpleShowLayout>
        <NumberField label="Id" source="id" />
        <TextField label="Meno" source="user.name" />
        <TextField label="Priezvisko" source="user.surname" />
        <TextField label="E-mail" source="user.email" />
        <TextField label="Tel." source="user.phoneNumber" />
        <ChipArrayField choices={USER_ROLES} label="Role" sortable={false} source="user.roles" />
        <ArrayField label="Mestá pôsobenia" sort={{ field: 'name', order: 'ASC' }} source="serviceLocations">
          <SingleFieldList linkType={false}>
            <ChipField source="name" />
          </SingleFieldList>
        </ArrayField>
        <ChipArrayField choices={SERVICE_AREA_TYPES} label="Licencie" sortable={false} source="serviceAreas" />
        <DateField label="Dátum vytvorenia" locales="sk" showTime={true} source="creationTimestamp" />
        <DateField label="Dátum zmeny" locales="sk" showTime={true} source="updateTimestamp" />
      </SimpleShowLayout>
    </Show>
  );
};
